import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, StaticQuery } from 'gatsby';
import ReactHtmlParser from 'react-html-parser';
import { Row, Col } from 'react-flexbox-grid';
import Slider from 'react-slick';
import {
  Image,
  Paragraph,
  SectionHeader,
  Section,
  IconSVG,
  SliderArrow,
} from 'components';
import './ClientQuotes.scss';
import { data } from './logic';

class NewsSlider extends Component {
  constructor() {
    super();

    this.state = {
      sliderSettings: {
        className: 'client-quotes',
        dotsClass: 'slick-dots slick-pagination',
        arrows: true,
        dots: true,
        autoplay: false,
        adaptiveHeight: false,
        infinite: true,
        draggable: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SliderArrow id={'client-qotes-next'} />,
        prevArrow: <SliderArrow id={'client-qotes-prev'} left />,
      },
    };
  }

  renderSlides = loadedData =>
    data.map((item, index) => (
      <div
        className={'client-quotes__slide-wrapper'}
        key={`news-slide-${index}`}
      >
        <div className={'client-quotes__slide'}>
          <div className={'client-quotes__item'}>
            <div className={'client-quotes__header'}>
              <IconSVG name={'quote'} size={'medium'} color={'black'} />
              <Image
                src={loadedData[item.image].childImageSharp.fixed}
                additionalClass={'client-quotes__logo'}
                type="fixed"
              />
              <Paragraph
                color={'black'}
                additionalClass={'client-quotes__author'}
              >
                {ReactHtmlParser(item.author)}
              </Paragraph>
            </div>
            <Paragraph
              color={'white'}
              additionalClass={'client-quotes__content'}
              size={'medium'}
            >
              {ReactHtmlParser(item.quote)}
            </Paragraph>
          </div>
        </div>
      </div>
    ));

  render() {
    const { sliderSettings } = this.state;

    return (
      <StaticQuery
        query={graphql`
          query {
            norbertImage: file(
              relativePath: { eq: "development-teams/norbert-sonnen.png" }
            ) {
              childImageSharp {
                fixed(width: 60) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
            alexImage: file(
              relativePath: { eq: "development-teams/alex-polco.png" }
            ) {
              childImageSharp {
                fixed(width: 60) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
            neilImage: file(
              relativePath: { eq: "development-teams/neil-sabco.png" }
            ) {
              childImageSharp {
                fixed(width: 60) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
          }
        `}
        render={loadedData => (
          <Section color={'pigeon-post'}>
            <Row className={'no-gap'}>
              <Col sm={12} md={6}>
                <div className={'development-teams__problem'}>
                  <SectionHeader
                    color={'white'}
                    size={'big'}
                    lineColor={'black'}
                    fixed
                    headingType={2}
                  >
                    Clients about
                    <br />
                    our teams
                  </SectionHeader>
                </div>
              </Col>
              <Col sm={12} md={6}>
                <Slider {...sliderSettings}>
                  {this.renderSlides(loadedData)}
                </Slider>
              </Col>
            </Row>
          </Section>
        )}
      />
    );
  }
}

NewsSlider.defaultProps = {
  data: null,
};

NewsSlider.propTypes = {
  data: PropTypes.array,
};

export default NewsSlider;
